class employees {
constructor(
 empId,
 name,
 file,
 
){
    this.empId = empId
    this.name = name
    this.file = file
    this.label = name + " " + "(" + file +")"

}
static fromJson({
    EmpId,
    Nombre,
    Legajo
}){
    return new employees(
        EmpId,
        Nombre,
        Legajo
    )
}
}
export default employees
